import darkTheme from "./dark";
import lightTheme from "./light";
export const themes = {
    light: lightTheme,
    dark: darkTheme
}
export default darkTheme